import React from 'react'
import { moduleContext } from 'react-contextual'

const PaymentsProvider = moduleContext()(({ context, children, ...props }: any) => {
  const store = {
    ...props,
  }
  return <context.Provider value={store}>{children}</context.Provider>
})

export default PaymentsProvider
